/**
 * @module Strings
 */

/**
 * Converts a given string into a camelized representation.
 * @param {string} text The string to camelize.
 * @example
 * // returns helloWorld
 * camelize('Hello World')
 */
export function camelize(text)
{
    return text.replace(/^([A-Z])|[\s-_]+(\w)/g, function(match, p1, p2, offset)
    {
        if (p2) return p2.toUpperCase();
        return p1.toLowerCase();        
    });
}